import {Box, Button, Flex, Heading, HStack, Image, Stack, Text} from "@chakra-ui/react";
import {useContext} from "react";
import {AuthContext, AuthContextI} from "./FirebaseAuth";

type Props = {
    onRefresh: () => void,
    isRefreshing: boolean
}

const NoAccessGate = ({onRefresh, isRefreshing}: Props) => {
    const authContext: AuthContextI = useContext<AuthContextI>(AuthContext);
    const email = authContext.getAuthUser()?.email;

    return (
        <Flex minH={"100dvh"} align={"center"} justify={"center"} bg={"gray.50"} px={4} py={6}>
            <Box
                w={"100%"}
                maxW={"460px"}
                borderRadius={"xl"}
                overflow={"hidden"}
                borderWidth={"1px"}
                borderColor={"gray.200"}
                bg={"white"}
                boxShadow={"lg"}
            >
                <Box px={6} py={6} bgGradient={"linear(to-r, teal.500, blue.500)"} color={"white"}>
                    <Flex alignItems={"center"} justifyContent={"space-between"} gap={4}>
                        <Box>
                            <Text fontSize={"xs"} letterSpacing={"0.3em"} textTransform={"uppercase"}>
                                SoundSpots
                            </Text>
                            <Heading size={"md"} mt={2}>Access pending</Heading>
                            <Text fontSize={"sm"} mt={1} opacity={0.9}>
                                {email ? `Signed in as ${email}` : "Signed in"}
                            </Text>
                        </Box>
                        <Image src={"/branding/logo.svg"} alt={"SoundSpots"} height={"64px"}/>
                    </Flex>
                </Box>
                <Box px={6} py={6}>
                    <Stack spacing={4}>
                        <Text fontSize={"sm"} color={"gray.700"}>
                            Your account isn't part of any organization yet. Ask an administrator to send you an
                            invitation, then come back here and tap Refresh.
                        </Text>
                        <HStack spacing={3}>
                            <Button
                                colorScheme={"teal"}
                                onClick={onRefresh}
                                isLoading={isRefreshing}
                                loadingText={"Checking"}
                            >
                                Refresh
                            </Button>
                            <Button variant={"outline"} onClick={authContext.signOut}>
                                Sign out
                            </Button>
                        </HStack>
                    </Stack>
                </Box>
            </Box>
        </Flex>
    );
}

export default NoAccessGate;
